const desktop = theme => {
  const {toVW} = theme;
  return {
    gameInfoArea: {
      top: '33%',
    },
  };
};

const mobile = theme => {
  return {
    gameInfoArea: props => ({
      position: 'absolute',
      fontSize: 12,
      display: 'flex',
      color: 'white',
      zIndex: 4,
      left: '50%',
      transform: 'translate(-50%,0)',
      top: '28%',
      opacity: 0.5,
      flexDirection: 'column',
      alignItems: 'center',
      rowGap: 5,
    }),
    gameMode: {
      display: 'flex',
      flexDirection: 'row',
      margin: '0 5px',
    },
    tournamentInfoContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    multiUnitContainer: {
      '& .ant-statistic-content-prefix': {
        marginRight: 0,
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
